import { For, Show } from "solid-js";
import type { TocItem } from "~/routes/(static)/blog/posts";

function TocLinks(props: { toc: TocItem[] }) {
  return (
    <For each={props.toc}>
      {(item) => (
        <a
          href={`#${item.slug}`}
          class={`block border-l border-primary-border py-1.5 pr-1 text-sm leading-snug text-secondary-text no-underline transition-colors hover:border-accent hover:text-primary-text ${item.depth === 3 ? "pl-7" : "pl-3.5"}`}
        >
          {item.text}
        </a>
      )}
    </For>
  );
}

export function OnThisPage(props: { toc: TocItem[] }) {
  return (
    <Show when={props.toc.length > 0}>
      <nav aria-label="On this page" class="flex flex-col">
        <span class="mb-2.5 text-xs font-bold tracking-wider text-muted-text uppercase">On this page</span>
        <TocLinks toc={props.toc} />
      </nav>
    </Show>
  );
}

/** The on-this-page list folded into a native disclosure, for widths without the side rail. */
export function OnThisPageCollapsed(props: { toc: TocItem[] }) {
  return (
    <Show when={props.toc.length > 0}>
      <details class="group rounded-xl border border-primary-border bg-panel px-4">
        <summary class="flex min-h-12 cursor-pointer list-none items-center justify-between gap-3 text-[15px] font-semibold text-primary-text [&::-webkit-details-marker]:hidden">
          On this page
          <span class="text-sm font-normal text-secondary-text">
            {props.toc.length} sections <span class="inline-block transition-transform group-open:rotate-180">▾</span>
          </span>
        </summary>
        <nav aria-label="On this page" class="pb-3">
          <TocLinks toc={props.toc} />
        </nav>
      </details>
    </Show>
  );
}
